<template>
  <div :class="['discountsHourlyProductSummaryBox', getWrapperClass, boxSize]">
    <a
      :href="getCampaignLink"
      class="adaptLink">
      <div class="img">
        <imageView
          :image="data.image"
          :desiredSize="imageSize"
          :useBackEndSize="ifCampaignTypeList"
          :fitByHeight="ifCampaignTypeList"
          class="cover"/>
        <div class="lockContent"></div>
      </div>
      <div class="content">
        <div class="titleSection">
          <div class="title">
            <span class="titleInner">{{ data.campaignName ? data.campaignName : (data.product && data.product.name) }}</span>
          </div>
        </div>
        <div class="detailSection">
          <span class="detailButton">Ürünü İncele</span>
        </div>
      </div>
    </a>
  </div>
</template>
<script>
import imageView from "../../../components/imageView/imageView";

import {isMobileDeviceOrScreen} from "../../../common/agent/agentUtils";
import {getImageSize} from "../../../utils/imageUtils";

import {PLATFORMS} from "../../../common/constants/constants";
import {BOX_SIZES, PRODUCT_IMAGE_SIZES} from "./discountsHourlyProductSummaryBoxConstants";

export default {
  name: "discountsHourlyProductSummaryBox",
  data() {
    return {};
  },
  props: {
    data: Object,
    boxSize: {
      validator: function(value) {
        return (
          [BOX_SIZES.SMALL, BOX_SIZES.MEDIUM, BOX_SIZES.LARGE].indexOf(
            value
          ) !== -1
        );
      }
    }
  },
  computed: {
    ifCampaignTypeList: function () {
      return this.data.campaignType == 'liste';
    },
    getWrapperClass: function () {
      return this.ifCampaignTypeList
        ? 'campaingTypeList'
        : 'campaingTypeProduct';
    },
    getCampaignLink: function() {
      if(this.ifCampaignTypeList && this.data.isHero) {
        return this.data.linkDirection
      }

      return this.ifCampaignTypeList
        ? this.data.campaignLink
        : this.data.product.url;
    },
    imageSize: function() {
      return isMobileDeviceOrScreen()
        ? PRODUCT_IMAGE_SIZES[PLATFORMS.MOBILE][this.boxSize]
        : PRODUCT_IMAGE_SIZES[PLATFORMS.DESKTOP][this.boxSize];
    }
  },
  components: {
    imageView,
  },
};
</script>

<style src="./discountsHourlyProductSummaryBox.scss" lang="scss" scoped/>



// WEBPACK FOOTER //
// src/view/productSummaryBoxes/discountsHourlyProductSummaryBox/discountsHourlyProductSummaryBox.vue